import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from '../api';
import { EnvironmentService } from '../services';
import { LanguageService } from '../language';

/**
 * This interceptor adds the headers to all request.
 *
 * @export
 * @class HttpTokenInterceptor
 * @implements {HttpInterceptor}
 */
@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(private readonly injector: Injector) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tokenService: TokenService = this.injector.get<TokenService>(TokenService);
    const environmentService: EnvironmentService = this.injector.get<EnvironmentService>(EnvironmentService);
    const languageService: LanguageService = this.injector.get<LanguageService>(LanguageService);

    const headersConfig = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin':
        environmentService && environmentService.environment ? environmentService.environment.apiUrl : '*',
      Accept: 'application/json',
    };

    headersConfig['Accept-Language'] = languageService.currentLang;

    if (tokenService.hasToken()) {
      headersConfig['Authorization'] = `Bearer ${tokenService.getToken()}`;
    }

    const request = req.clone({ setHeaders: headersConfig });
    return next.handle(request);
  }
}
